export default __webpack_public_path__ + "static/media/qris.0250fc5e.png";